import { IUser } from '../../types/redux';

const defaultState: IUser = {
  isAuthenticated: false,
};

export function userReducer(state: IUser = defaultState) {
  return state;
}
